import { DateTime } from "@bps/date-time";

export interface RefDataDto<T extends string = string> {
  id?: string;
  code: T;
  text: string;
  sortOrder?: number;
  isActive: boolean;
  etag?: string;
  changeLog?: ChangeLog;
}

export type RefDataResponse = Omit<RefDataDto, "changeLog"> & {
  changeLog: ChangeLogDto;
};

export interface ChangeLog {
  createdDate?: DateTime;
  createdBy?: string;
  updatedDate?: DateTime;
  updatedBy?: string;
}

export interface ChangeLogDto {
  createdBy?: string;
  createdDate?: string;
  updatedBy?: string;
  updatedDate?: string;
}

export const SITE_ID_PREFIX = "BPS-";
